import { secureGet, securePost, securePut } from '../../Config/ApiConfig';

export const getTransactions = async ({ page, size, sort_by, sort_direction, filters, search_string, signal }, is_admin) => {
    const params = new URLSearchParams();
    params.set('page', String(page ?? 1));
    params.set('page_size', String(size ?? 10));

    const trimmedSearch = typeof search_string === 'string' ? search_string.trim() : search_string;
    if (trimmedSearch) {
        params.set('search_string', String(trimmedSearch));
    }
    if (sort_by) {
        params.set('sort_by', String(sort_by));
    }
    if (sort_direction) {
        params.set('sort_direction', String(sort_direction));
    }

    // Remove empty filter values (undefined/null/''/[]/{}) so backend only receives meaningful filters.
    const cleanedFilters = Object.entries(filters || {}).reduce((acc, [key, value]) => {
        if (value === undefined || value === null || value === '') return acc;
        if (Array.isArray(value) && value.length === 0) return acc;
        if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) return acc;
        acc[key] = value;
        return acc;
    }, {});

    if (Object.keys(cleanedFilters).length > 0) {
        params.set('filters', JSON.stringify(cleanedFilters));
    }

    const base = `/transactions${!is_admin ? '/me' : ''}`;
    const url = `${base}?${params.toString()}`;
    const response = await secureGet(url, signal ? { signal } : {});
    return response.data;
};

export const updateTransaction = async (id, body) => {
    const { data } = await securePut(`/transactions/${id}`, body);
    return data;
};

export const reconcileTransaction = async (id) => {
    const { data } = await securePost('/transactions/' + id + '/reconcile');
    return data;
};

export const createTransaction = async (body) => {
    try {
        const response = await securePost('/transactions', body);
        return response.data;
    } catch (error) {
        throw error;
    }
};
